import Layout, { ContentLayout } from 'Layout';
import WorkforceTabsNavigation from '@users/presentation/components/WorkforceTabsNavigation';
import { Box, Typography } from '@mui/material';
import noPermissions from '@users/presentation/assets/images/no-permissions.png';

export const NoPermissions = () => (
  <Layout>
    <ContentLayout>
      <ContentLayout.Header sticky>
        <WorkforceTabsNavigation disabled />
      </ContentLayout.Header>
      <ContentLayout.Container alignItems="center" display="flex" justifyContent="center">
        <div style={{ textAlign: 'center', maxWidth: '600px' }}>
          <img
            alt="No permissions"
            src={noPermissions}
            style={{ marginBottom: '1.5rem', verticalAlign: 'bottom' }}
            width={115}
          />
          <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="h6">No tienes permisos para acceder a esta sección</Typography>
            <Typography variant="body1">
              Pide a quien administre los permisos de tu cuenta que te otorgue acceso para visualizar o editar Roles y
              Usuarios desde la configuración de permisos de tu Rol.
            </Typography>
          </Box>
        </div>
      </ContentLayout.Container>
    </ContentLayout>
  </Layout>
);
